<nav class="navbar sticky-top">
  <div class="container p-0 mobile-class">
    <div class="left-side-actions">
      <!-- <div class="btn-group mr-2">
        <button id="menu-button" type="button" class="button ghost__button medium__button" [routerLink]="['/dashboard']"
          [popover]="'Dashboard'" triggers="mouseenter:mouseleave" placement="bottom">
          <div class="m-0">
            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.6">
                <rect width="18" height="2" fill="white" />
                <rect y="5" width="18" height="2" fill="white" />
                <rect y="10" width="18" height="2" fill="white" />
              </g>
            </svg>
          </div>
        </button>
      </div> -->
      <!-- <div class="btn-group mr-2" dropdown>
        <button id="menu-button" type="button" dropdownToggle class="button ghost__button medium__button"
          aria-controls="menu-dropdown">
          <h4 class="m-0">
            <em class="fa fa-bars color--white"></em>
          </h4>
        </button>
        <div id="menu-dropdown" *dropdownMenu class="dropdown__container dropdown-menu dropdown__action" role="menu"
          aria-labelledby="menu-button">
          <div role="menuitem"><a class="dropdown-item" [ngClass]="{'active': currentPage === 'dashboard'}"
              [routerLink]="['/dashboard']"><em class="fa fa-columns mr-2"></em>Dashboard</a></div>
          <li class="divider dropdown-divider"></li>
          <div role="menuitem"><a class="dropdown-item" [routerLink]="[]"><em class="fa fa-star-o mr-2"></em>What’s
              new</a>
          </div>
          <div role="menuitem"><a class="dropdown-item" [routerLink]="[]"><em class="fa fa-file-text-o mr-2"></em>About
              us</a>
          </div>
          <div role="menuitem"><a class="dropdown-item" [routerLink]="[]"><em
                class="fa fa-comments-o mr-2"></em>Contact</a>
          </div>
        </div>
      </div> -->
      <div class="align-self-center ml-2">
        <h5 class="m-0" role="button" [routerLink]="['/dashboard']">
          <img class="valzy" src="../../../../assets/images/valzy.png" alt="...">
        </h5>
      </div>

      <!-- Report Name -->
      <div class="text-white handle-mobile-report">
        <!-- Regular Report -->
        <ng-container
          *ngIf="currentReport && currentReport.LATEST && currentReport.LATEST.COMPANY && !reportService.isQuickReport">
          <div class="report__title">
            {{currentReport.LATEST.COMPANY.NAME ? currentReport.LATEST.COMPANY.NAME
            : currentReport.LATEST.BORROWER_NAME ? currentReport.LATEST.BORROWER_NAME
              : currentReport.LATEST.COMPANY.DBA ? currentReport.LATEST.COMPANY.DBA
                : 'No Company Name'}}
          </div>
          <button *ngIf="currentReport?.CURRENT_ALG_VERSION && currentReport?.LATEST?.ALG_VERSION && reportService.outdatedVersion()"
                  class="button extra__small__button half-rounded__button ml-2 ellipsis primary__button"
                  [popover]="'This Report Version uses Algorithm Version ' + currentReport.LATEST.ALG_VERSION + ', Latest available is ' + currentReport.CURRENT_ALG_VERSION + ' Click to Upgrade'"
                  triggers="mouseenter:mouseleave" [placement]="'bottom'" (click)="updateAlgVersion()">
            {{currentReport.LATEST.ALG_VERSION}}
          </button>
          <small role="button" class="text-muted ml-3 save-and-close-desktop" [routerLink]="['/dashboard']">
            Save and close
            <em class="fa fa-times"></em>
          </small>
          <small role="button" class="text-muted ml-3 save-and-close-mobile" [routerLink]="['/dashboard']">
            <em class="fa fa-floppy-o"></em>
          </small>
        </ng-container>

        <!-- Express Valuation -->
        <ng-container *ngIf="reportService.isQuickReport">
          <div class="report__title express">Express Valuation</div>
          <small role="button" class="text-muted ml-3 handle-express-mobile" [routerLink]="['/dashboard']">
            <span>close</span>
            <em class="fa fa-times"></em>
          </small>
        </ng-container>
      </div>
    </div>

    <div class="text-secondary desktop-nav">
      @if(userService.checkAdminRole() && adminSettingsActive){
        <button type="button" class="button ghost__button medium__button color--white" (click)="adminSettingClick()"
                [popover]="'Close Admin Panel'" triggers="mouseenter:mouseleave" placement="top" [adaptivePosition]="true" container="body">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.20005 1.6458L8.35405 0.799805L5.00005 4.15381L1.64605 0.799805L0.800049 1.6458L4.15405 4.99981L0.800049 8.35381L1.64605 9.19981L5.00005 5.84581L8.35405 9.19981L9.20005 8.35381L5.84605 4.99981L9.20005 1.6458Z" fill="white" />
          </svg>
        </button>

        <button type="button" class="button ghost__button medium__button expandable__btn" id="report-setting-button"
                [routerLink]="['/administrator-settings/reports']" routerLinkActive="active">
          <em class="admin__report__icon mr-2" [class.admin__report__icon__white__imp]="currentPage === 'reports'"></em>
          <span class="expandable__lbl">Reports</span>
        </button>

        <button type="button" class="button ghost__button medium__button expandable__btn" id="user-setting-button"
                [routerLink]="['/administrator-settings/users']" routerLinkActive="active">
          <em class="admin__users__icon mr-2" [class.admin__users__icon__white__imp]="currentPage === 'users'"></em>
          <span class="expandable__lbl">Users</span>
        </button>

        <button type="button" class="button ghost__button medium__button expandable__btn" id="organization-setting-button"
                [routerLink]="['/administrator-settings/organizations']" routerLinkActive="active">
          <em class="admin__org__icon mr-2" [class.admin__org__icon__white__imp]="currentPage === 'organizations' || currentPage === 'organizations-details'"></em>
          <span class="expandable__lbl">Organizations</span>
        </button>

        <div class="btn-group mr-2" dropdown>
          <button type="button" dropdownToggle aria-controls="menu-dropdown"
                  class="button ghost__button medium__button expandable__btn" id="directory-setting-button">
            <em class="admin__directory__icon"
                [class.admin__directory__icon__white__imp]="currentPage === 'directory' || currentPage === 'directory-details' || currentPage === 'zip-codes' || currentPage === 'zip-code-details' || currentPage === 'franchise' || currentPage === 'franchise-details' || currentPage === 'promo-codes'">
            </em>
          </button>
          <div id="menu-dropdown" *dropdownMenu class="dropdown__container dropdown-menu dropdown-menu-right mt-0" role="menu"
               aria-labelledby="report-option">
            <div role="menuitem">
              <a class="dropdown-item report-option__box" [ngClass]="{'active': currentPage === 'directory' || currentPage === 'directory-details'}" [routerLink]="['/administrator-settings/directory']">
                <img src="../../../assets/images/naics-icon.svg" alt="...">
                <span>
                NAICS
              </span>
              </a>
            </div>
            <div class="divider dropdown-divider"></div>
            <div role="menuitem">
              <a class="dropdown-item report-option__box" [ngClass]="{'active': currentPage === 'franchise' || currentPage === 'franchise-details'}" [routerLink]="['/administrator-settings/franchise']">
                <img src="../../../assets/images/franchise-icon.svg" alt="...">
                <span>Franchise</span>
              </a>
            </div>
            <div class="divider dropdown-divider"></div>
            <div role="menuitem">
              <a class="dropdown-item report-option__box" [ngClass]="{'active': currentPage === 'zip-codes' || currentPage === 'zip-code-details'}" [routerLink]="['/administrator-settings/zip-codes']">
                <img src="../../../assets/images/zipcodes-icon.svg" alt="...">
                <span>Zipcodes</span>
              </a>
            </div>
            <div class="divider dropdown-divider"></div>
            <div role="menuitem">
              <a class="dropdown-item report-option__box" [ngClass]="{'active': currentPage === 'promo-codes'}" [routerLink]="['/administrator-settings/promo-codes']">
                <img src="../../../assets/images/promocodes-icon.svg" alt="...">
                <span>Promocodes</span>
              </a>
            </div>
            <div class="divider dropdown-divider"></div>
            <!--<div role="menuitem">
              <a class="dropdown-item report-option__box" [routerLink]="['/administrator-settings/subscription']">
                <img src="../../../assets/images/subscriptions-icon.svg" alt="...">
                <span>Subscriptions</span>
              </a>
            </div>-->
          </div>

        </div>

        <!-- Online Users -->
          <!--<button type="button" class="button ghost__button medium__button expandable__btn" id="online-setting-button"
            [routerLink]="['/administrator-settings/online']">
              <em class="admin__online__icon mr-2" [class.admin__online__icon__white__imp]="currentPage === 'online'"></em>
              <span class="expandable__lbl">Online Users</span>
          </button>-->
      }@else if(!adminSettingsActive){
        <button type="button" *ngIf="userService.checkAdminRole()"
                class="button ghost__button medium__button color--white expandable__btn" id="user-credit-button" (click)="adminSettingClick();">
          <em class="admin__setting__icon mr-2"></em>
          <span class="expandable__lbl">Admin Setting</span>
        </button>

        <!--<button type="button" [routerLink]="['/payment/transactions-history']" class="button ghost__button medium__button expandable__btn"
                id="transaction-history" *ngIf="!userService.isBrokerUser" routerLinkActive="active">
          <em class="payment__icon mr-2" [class.payment__icon__white__imp]="currentPage === 'transactions-history'"></em>
          <span class="expandable__lbl">Transactions History</span>
        </button>-->

        <button type="button" class="button ghost__button medium__button expandable__btn" id="feedback-button"
                (click)="openFeedbackPopup()" *ngIf="!isCheckoutPage">
          <em class="feedback__icon mr-2"></em>
          <span class="expandable__lbl">Feedback</span>
        </button>

        <!-- <div dropdown placement="bottom-right" (isOpenChange)="isChatOpenChange($event)"
          class='header-button c-header__dropdown' [insideClick]="true"
          [ngStyle]="{'background-color': chatOpen ? '#4164E2': null}">
          <button id="chat-button" dropdownToggle class="button ghost__button medium__button color--white">
            <img
              [src]="chatOpen ? '../../../../assets/images/chat-icon.svg' : '../../../../assets/images/chat-icon-light.svg'">
          </button>
          <app-chat></app-chat>
        </div> -->

          <!-- <em class="fa fa-users mr-4"></em> -->
          <!-- <div dropdown placement="bottom-right" (isOpenChange)="isNotificationOpenChange($event)"
            class='header-button c-header__dropdown' [ngStyle]="{'background-color': notificationOpen ? '#4164E2': null}">
            <button id="notification-button" dropdownToggle class="button ghost__button medium__button color--white">
              <h5 class="m-0">
                <img
                  [src]="notificationOpen ? '../../../../assets/images/bell.svg' : '../../../../assets/images/bell-light.svg'">
                <sup class="c-header-notification__badge"><span class="badge badge-pill badge-success">2</span></sup>
              </h5>
            </button>
            <app-notification></app-notification>
          </div> -->
      }

      <div class="btn-group" dropdown placement="bottom right">
        <button id="button-alignment" dropdownToggle type="button"
          class="button ghost__button medium__button color--gray--2" aria-controls="dropdown-alignment">
          <span class="header-name--info">{{userService.getUserFirstName()}}</span>
          <img class="ml-3" src="../../../../assets/images/arrow-down.svg" alt="...">
        </button>
        <ul id="dropdown-alignment" *dropdownMenu
          class="dropdown__container dropdown-menu dropdown-menu-right dropdown__action mt-0" role="menu"
          aria-labelledby="button-alignment">
          <li role="menuitem">
            <a class="dropdown-item" [routerLink]="['/account-setting']" routerLinkActive="active">Account Settings</a>
          </li>
          @if(!userService.isBrokerUser){
            <li class="divider dropdown-divider"></li>
            <li role="menuitem">
              <a class="dropdown-item" [routerLink]="['/payment/transactions-history']" routerLinkActive="active">Transactions History</a>
            </li>
          }
          <li class="divider dropdown-divider"></li>
          <ng-container *ngIf="userService.checkOrganizationAdmin()">
            <li role="menuitem">
              <a class="dropdown-item" [routerLink]="['/org-settings']" [ngClass]="{'active': currentPage === 'org-settings'}">
                Organization Settings
              </a>
            </li>
            <li class="divider dropdown-divider"></li>
          </ng-container>
          <li role="menuitem">
            <div class="dropdown-item" (click)="logOutClick()">Log Out</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- Mobile view navigation -->
    <div class="mobile-nav">
      <div class="mobile-nav-container">
        <button type="button" class="button medium__button mobile-handle" (click)="toggleMobileNav()">
          <em class="fa fa-bars font-size-20"></em>
        </button>
      </div>
      @if(mobileNavExpand){
        <div class="mobile-nav-content">
          <!-- Valzy icon + close icon -->
          <div class="top-icon-container">
            <h5 class="m-0" role="button" [routerLink]="['/dashboard']"
                (click)="toggleMobileNav();">
              <img class="valzy" src="../../../../assets/images/valzy.png" alt="...">
            </h5>

            <button type="button" class="button medium__button mobile-nav-close-handle" (click)="toggleMobileNav()">
              <em class="fa fa-close font-size-20"></em>
            </button>
          </div>

          <!-- Admin Setting -->
          <div class="mt-10">
            <button type="button" *ngIf="userService.checkAdminRole()"
                    class="button ghost__button medium__button color--white expandable__btn" id="mob-user-credit-button"
                    (click)="adminSettingClick(); toggleMobileNav(true);">
              <em class="admin__setting__icon mr-2"></em>
              <span class="expandable__lbl">Admin Setting</span>
            </button>
          </div>

          <div class="px-5" [collapse]="!adminSettingsActive" [isAnimated]="true">
            <div class="mt-10">
              <button type="button" class="button ghost__button medium__button expandable__btn" id="mob-report-setting-button"
                      [routerLink]="['/administrator-settings/reports']" routerLinkActive="active"
                      (click)="toggleMobileNav();">
                <em class="admin__report__icon mr-2" [class.admin__report__icon__white__imp]="currentPage === 'reports'"></em>
                <span class="expandable__lbl">Reports</span>
              </button>
            </div>

            <div class="mt-10">
              <button type="button" class="button ghost__button medium__button expandable__btn" id="mob-user-setting-button"
                      [routerLink]="['/administrator-settings/users']" routerLinkActive="active"
                      (click)="toggleMobileNav();">
                <em class="admin__users__icon mr-2" [class.admin__users__icon__white__imp]="currentPage === 'users'"></em>
                <span class="expandable__lbl">Users</span>
              </button>
            </div>

            <div class="mt-10">
              <button type="button" class="button ghost__button medium__button expandable__btn" id="mob-organization-setting-button"
                      [routerLink]="['/administrator-settings/organizations']" routerLinkActive="active"
                      (click)="toggleMobileNav();">
                <em class="admin__org__icon mr-2" [class.admin__org__icon__white__imp]="currentPage === 'organizations' || currentPage === 'organizations-details'"></em>
                <span class="expandable__lbl">Organizations</span>
              </button>
            </div>

            <div class="mt-10">
              <button type="button" class="button ghost__button medium__button expandable__btn pl-0" id="mob-naics-button"
                      [routerLink]="['/administrator-settings/directory']" routerLinkActive="active"
                      (click)="toggleMobileNav();">
                <img class="mr-2" src="../../../assets/images/naics-icon.svg" alt="...">
                <span class="expandable__lbl">NAICS</span>
              </button>
            </div>

            <div class="mt-10">
              <button type="button" class="button ghost__button medium__button expandable__btn pl-0" id="mob-franchise-button"
                      [routerLink]="['/administrator-settings/directory']" routerLinkActive="active"
                      (click)="toggleMobileNav();">
                <img class="mr-2" src="../../../assets/images/franchise-icon.svg" alt="...">
                <span class="expandable__lbl">Franchise</span>
              </button>
            </div>

            <div class="mt-10">
              <button type="button" class="button ghost__button medium__button expandable__btn pl-0" id="mob-zipcodes-button"
                      [routerLink]="['/administrator-settings/directory']" routerLinkActive="active"
                      (click)="toggleMobileNav();">
                <img class="mr-2" src="../../../assets/images/zipcodes-icon.svg" alt="...">
                <span class="expandable__lbl">Zipcodes</span>
              </button>
            </div>

            <div class="mt-10">
              <button type="button" class="button ghost__button medium__button expandable__btn pl-0" id="mob-promocodes-button"
                      [routerLink]="['/administrator-settings/directory']" routerLinkActive="active"
                      (click)="toggleMobileNav();">
                <img class="mr-2" src="../../../assets/images/promocodes-icon.svg" alt="...">
                <span class="expandable__lbl">Promocodes</span>
              </button>
            </div>
          </div>

          <!-- Feedback -->
          <div class="mt-10" *ngIf="!isCheckoutPage">
            <button type="button" class="button ghost__button medium__button expandable__btn" id="mob-feedback-button"
                  (click)="openFeedbackPopup(); toggleMobileNav();">
              <em class="feedback__icon mr-2"></em>
              <span class="expandable__lbl">Feedback</span>
            </button>
          </div>

          <!-- Profile Button -->
          <div class="mt-10">
            <button id="mob-profile-button" type="button" (click)="toggleProfileNav()"
                    class="button ghost__button medium__button color--gray--2">
              <span class="header-name--info">{{userService.getUserFirstName()}}</span>
              <img class="ml-3" src="../../../../assets/images/arrow-down.svg" alt="...">
            </button>
          </div>

          <div class="px-5" [collapse]="!profileNavExpand" [isAnimated]="true">
            <div class="mt-10">
              <button type="button" class="button ghost__button medium__button expandable__btn" id="mob-account-setting-button"
                      [routerLink]="['/account-setting']" routerLinkActive="active" (click)="toggleMobileNav();">
                <span class="expandable__lbl">Account Settings</span>
              </button>
            </div>
            @if(!userService.isBrokerUser){
              <div class="mt-10">
                <button type="button" class="button ghost__button medium__button expandable__btn" id="mob-transactions-history-button"
                        [routerLink]="['/payment/transactions-history']" routerLinkActive="active" (click)="toggleMobileNav();">
                  <span class="expandable__lbl">Transactions History</span>
                </button>
              </div>
            }
            <div class="mt-10" *ngIf="userService.checkOrganizationAdmin()">
              <button type="button" class="button ghost__button medium__button expandable__btn" id="mob-org-setting-button"
                      [routerLink]="['/org-settings']" routerLinkActive="active" (click)="toggleMobileNav();">
                <span class="expandable__lbl">Organization Settings</span>
              </button>
            </div>
            <div class="mt-10">
              <button type="button" class="button ghost__button medium__button expandable__btn" id="mob-logout-button"
                      (click)="logOutClick(); toggleMobileNav();">
                <span class="expandable__lbl">Logout</span>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</nav>
